<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">Q-Flow</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">Q-Flow简介</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            Q-Flow主要用于辅助用户使用龙讯第一性原理计算软件<a
              href="http://www.lonxun.com/pwmat-introduce"
              >PWmat</a
            >，它具有良好的图形界面，并且兼具计算、数据存储、数据处理、数据展示等功能，与云平台应用<a
              href="//www.pwmat.com/qstudio-introduce"
              >Q-Studio</a
            >配合，可以完成从材料建模到性质模拟的一整套流程。目前，Q-Flow
            v1.0版本已于2022年4月正式登陆<a
              href="http://www.lonxun.com/mcloud-introduce"
              >龙讯超算云平台</a
            >，已注册用户可以直接点击Q-Flow图标打开应用，开展物理、化学、生物等领域的科研和教学工作。
          </p>
          <div class="mstation-introduce-content-img">
            <img
              class="mstation-introduce-content-img-png"
              src="../../assets/produce/PWMGUI/qflow-function.png"
            />
          </div>
          <p class="pwmat-introduce-content-info-text">
            Q-Flow采用B/S架构，其中计算参数设置、计算流程设置、结果展示等功能部署于浏览器端，模拟计算、数据存储、数据处理等功能部署在服务器端。
          </p>
          <p class="pwmat-introduce-content-info-text">
            Q-Flow在操作上简单、便捷、易上手，拖拽式的组件和模板使用户可以快速完成计算流程设计。交互式图形界面使得计算参数设置准确、可靠、合理，减少用户学习成本，提高计算可靠性和稳定性。
          </p>
          <p class="pwmat-introduce-content-info-text">
            Q-Flow中计算、数据处理、数据存储功能部署在服务器，由PWmat、PWmat顶层模块、作业调度系统、前/后处理程序共同完成。用户无需熟悉Linux系统和操作，而是通过浏览器直接访问后端已处理数据，高效、实时地获取计算进度、计算结果和计算生成文件。
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/1登录.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">
            通过龙讯超算云平台访问Q-Flow
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/2上传结构.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">
            上传模型到私人结构库
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/3查看结构.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">快速查看模型</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/4创建项目.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">创建项目</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/5创建工作流.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">创建工作流</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/6工作流设计.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">设计工作流</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/7部分参数设置.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">设置计算参数</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/8提交作业.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">提交作业开始计算</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/9计算状态查询.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">查看计算状态</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/PWMGUI/10查看计算结果.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">查看计算结果</p>
        </div>
        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">相关下载</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toMSTATIONDownload"
          >
            PWmat下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toModuleDownload"
          >
            Module下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toManual"
          >
            手册下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toPotentialDownload"
          >
            赝势下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='http://mcloud-doc.lonxun.com'"
          >
            Mcloud手册
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-introduce-content-info-img-text {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-top: 6px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.mstation-introduce-content-img {
  text-align: center;
}
.mstation-introduce-content-img-png {
  margin-top: 20px;
  width: 100%;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
